import { Typography } from "@mui/material";
import React from "react";
import { StyledVoiceVisualization } from "../../styled/voiceVisualization";

const VoiceVisualization = ({ listening, transcript }) => {
  return (
    <StyledVoiceVisualization.Dialog
      open={listening}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}>
      <StyledVoiceVisualization.MicIcon />
      <Typography color="secondary" variant="h6">
        Escuchando...
      </Typography>
      <StyledVoiceVisualization.TranscriptTypography
        color="primary"
        variant="body1">
        {transcript}
      </StyledVoiceVisualization.TranscriptTypography>
    </StyledVoiceVisualization.Dialog>
  );
};

export default VoiceVisualization;
